import apiHandler from "./apiHandler";

import { defaultPagination } from "@/utils/helpers";

const apiAwards = {
  details: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/award/${id}`)
        .then((response) => {
          if (
            response.data.details !== null &&
            response.data.details.airframes !== undefined
          ) {
            response.data.details.airframes.forEach((item, i) => {
              if (item == "small")
                response.data.details.airframes[i] = "pax_small";
              if (item == "medium")
                response.data.details.airframes[i] = "pax_medium";
              if (item == "large")
                response.data.details.airframes[i] = "pax_large";
              if (item == "ga") response.data.details.airframes[i] = "pax_ga";
              if (item == "bizjet")
                response.data.details.airframes[i] = "pax_bizjet";
            });
          }
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  progress: (id) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/award/${id}/progress`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  pilots: (award, pagination, needle) => {
    return new Promise((resolve, reject) => {
      defaultPagination(pagination);
      apiHandler
        .post(`/award/${award._id}/pilots`, {
          skip: (pagination.page - 1) * pagination.rowsPerPage,
          count: pagination.rowsPerPage,
          needle: needle,
          sort: pagination.sortBy !== null ? pagination.sortBy : "",
          order: pagination.descending ? -1 : 1,
        })
        .then((response) => {
          pagination.rowsNumber = response.data.totalResults;
          resolve({
            results: response.data.results,
            pagination,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiAwards;
